import React from "react";
import "../NearMe.css";

const FacialsNearMeHead = () => {
  return (
    <div className="nearHeadContainer">
      <h2>Facials Near Me: Experience Luxurious Skincare at SCENT  </h2>
      <p>
        When it comes to maintaining a radiant complexion and healthy skin,
        facials are an essential part of any beauty regimen. If you're on the
        lookout for <a href="/facials-near-me">"facials near me"</a>, SCENT
        Salon is the perfect destination. Conveniently located and renowned for
        its exceptional skincare services,
        <a href="/facial">SCENT  offers a variety of facial treatments</a>
        designed to address diverse skin concerns and enhance your natural
        beauty.
      </p>
    </div>
  );
};

export default FacialsNearMeHead;
